<template>
		<transition name="fade">
            <div id="pagetop" ref="BackToTop" class="back-to-top" v-show="scY > 800" @click="toTop">
                <SvgIcon class="back-to-top__icon" iconName="ico-arrow-up"/>
            </div>
        </transition>
</template>

<script>
import SvgIcon from '@/components/base/SvgIcon/SvgIcon';

export default {
	props: {
		data: {
			type: Object,
			requested: true
		}
	},

	data() {
		return {
			scTimer: 0,
			scY: 0
		};
	},
	components: {
		SvgIcon
	},
	mounted() {
		window.addEventListener('scroll', this.handleScroll);
		this.scroll();
	},
	methods: {
		handleScroll: function () {
			if (this.scTimer) return;
			this.scTimer = setTimeout(() => {
				this.scY = window.scrollY;
				clearTimeout(this.scTimer);
				this.scTimer = 0;
			}, 100);
		},
		toTop: function () {
			window.scrollTo({
				top: 0,
				behavior: 'smooth'
			});
		},
		scroll() {
			let isScrolling;
			const BackToTop = document.querySelector('.back-to-top');
			window.addEventListener('scroll', function(event) {
				BackToTop.classList.remove('hide-btn');
				window.clearTimeout(isScrolling);
				isScrolling = setTimeout(function() {
					BackToTop.classList.add('hide-btn');
				}, 2000);
			}, false);
		}
	}
};
</script>

<style lang="scss" scoped>
.back-to-top {
	bottom: 20px;
	right: 0;
	position: fixed;
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 0 25px;
	height: 50px;
	width: 50px;
	padding: 15px;
	font-size: 30px;
	color: $fiord;
	transition: $dur $ease;
	background-color: $white;
	border-radius: 100%;
	cursor: pointer;
	z-index: 9999999;

	&::before,
	&::after {
		box-sizing: inherit;
		content: '';
		border-radius: 100%;
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		border: 2px solid $fiord;
		box-shadow: none;
		transition: $dur $ease;
	}

	&::after {
		border: 0 solid $fiord;
	}

	@include hover {
		color: $dodger-blue;
		&::before {
			border: 2px solid $dodger-blue;
		}

		&::after {
			border: 2px solid $dodger-blue;
		}
	}
}

.hide-btn {
	opacity: 0;
	visibility: hidden;
}

.back-to-top__icon {
	font-size: 40px;
}
</style>
